import {
  ExpandableSection,
  ExpandableSectionSummary,
  FileUploader,
  VerticalFormField,
} from "components/common/wintForms";
import { FileUploaderProps } from "models/propTypes/wintFormPropsTypes";
import { UploadedFile } from "models/utilTypes/fileUtilsTypes";
import { LocalizationHelperInstance } from "utils/helpers";
import { TranslationKeys } from "translations";
import { ReceiptFileUploaderFieldProps } from "models/propTypes/receiptPropTypes";

const ReceiptFileUploaderField: React.FC<ReceiptFileUploaderFieldProps> = ({
  connect,
  expandableStepProps,
  onChange,
}) => {
  const filesToUploadConnect = connect("filesToUpload");

  const onFilesUpload = (value?: UploadedFile[]) => {
    filesToUploadConnect.setValue(value);
    onChange?.(value ?? []);
  };

  return (
    <ExpandableSection
      summary={
        <ExpandableSectionSummary
          title={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.AttachedFiles)}
        />
      }
      initiallyOpen
      hasErrors={filesToUploadConnect.hasErrors}
      {...expandableStepProps}
    >
      <VerticalFormField<FileUploaderProps>
        Component={FileUploader}
        {...filesToUploadConnect}
        setValue={onFilesUpload}
        fileUploaderType="full"
      />
    </ExpandableSection>
  );
};

export default ReceiptFileUploaderField;
